module.exports = __webpack_public_path__ + "img/pickup.41f095ef.svg";